import { doorClient, hiManagerClient, resolve } from 'services/api';
import dayjs from 'lib/dayjs';

function transformParams(origin: Todo.Data.Filter): Todo.Data.Params {
  const { timeRange, departmentIds, platform, storeInfo, ...others } = origin;
  const [timeBegin, timeEnd] = timeRange || [];
  return {
    timeBegin: Number(dayjs(timeBegin, 'YYYY-MM-DD').startOf('day').format('X') * 1000),
    timeEnd: Number(dayjs(timeEnd, 'YYYY-MM-DD').endOf('day').add(1, 'second').format('X') * 1000),
    departmentIds: departmentIds ? departmentIds.map((item) => item.id) : [],
    platforms: platform === 'ALL' || platform === undefined ? [] : [platform],
    storeIds: storeInfo?.list?.map((each) => each.id) || [],
    ...others,
  };
}

export const getTodoCreateTrend = (params: Todo.Data.Params) => {
  return resolve(
    doorClient.post('/overseaim-hi-manager/v1/getTodoCreateTrends', transformParams(params)),
  );
};

export const getTodoStatsSummary = (params: Todo.Data.Params) => {
  return resolve(
    doorClient.post('/overseaim-hi-manager/v1/getTodoStatsSummary', transformParams(params)),
  );
};

export const getTodoOverviewList = (params: Todo.Data.Params) => {
  return resolve(
    doorClient.post('/overseaim-hi-manager/v1/getTodoOverviewList', transformParams(params)),
  );
};

export const exportTodoOverview = (params: Todo.Data.Params) => {
  return resolve(
    doorClient.post('/overseaim-hi-manager/v1/exportTodoOverview', transformParams(params)),
  );
};

export const getTaskPolicyType = () => {
  return resolve<
    {
      type: number;
      source: 0 | 1;
      name: string;
    }[]
  >(hiManagerClient.get('/getTaskPolicyType'));
};
